import React from 'react';
import classNames from 'classnames';
import styles from './logo.module.scss';

interface LogoProps {
  link?: string;
  src: string;
  width: string;
  height: string;
  target?: string;
  className?: string;
}

const Logo = (props: LogoProps) => (!props.link ? (
  <img
    className={classNames(styles['img-logo'], props.className)}
    alt="logo"
    src={props.src}
    width={props.width}
    height={props.height}
  />
) : (
  <a href={props.link || '#'} className={styles.logo} target={props.target || '_self'}>
    <img
      className={styles['img-logo']}
      alt="logo"
      src={props.src}
      width={props.width}
      height={props.height}
    />
  </a>
));

export default Logo;
